import store from 'shared/store'
import { SELLER_MODAL_CONTAINER_ID } from 'views/components/organisms/SellerModal/names'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

import { OPEN_SELLER_MODAL } from './clientsideHook'

const handleButtonClick = async (sellerId, sellerModal) => {
  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()

  const catalogs = await loadCatalogs(locale)

  try {
    const sellerModalContainer = await import(
      /* webpackChunkName: "SellerModalContainerWithRender" */
      './SellerModalContainerWithRender'
    )

    sellerModalContainer.default({
      container: sellerModal,
      sellerId,
      catalogs,
    })
  } catch (err) {
    throw new Error(err)
  }
}

export default () => {
  const sellerModalButtons = document.querySelectorAll(
    `[data-clientside-hook*="${OPEN_SELLER_MODAL}"]`
  )
  const sellerModal = document.getElementById(SELLER_MODAL_CONTAINER_ID)

  if (!sellerModalButtons.length || !sellerModal) {
    return
  }

  sellerModalButtons.forEach(button => {
    const sellerId = button
      .getAttribute('data-clientside-hook')
      .match(new RegExp(`${OPEN_SELLER_MODAL}--(.+)$`))[1]

    if (!sellerId) {
      return
    }

    button.addEventListener('click', () =>
      handleButtonClick(sellerId, sellerModal)
    )
  })
}
